import { guardianColors } from '@/theme/colors';

export const LEVEL_DETAIL_STATUS_COLORS = {
  earned: guardianColors['Main/Main'],
  working: guardianColors['Primary Color'],
  notStarted: guardianColors[5],
} as const;
